import { useMemo } from 'react';

import { CDN_URL } from '@webapp/common/conf';
import { forceHeader } from '@webapp/common/lib/const';
import { BackgroundType, calcHeaderHeight } from '@webapp/common/lib/ui';
import type { InfoDesignModel } from '@webapp/common/resources/entities/info';

export const useSurveyStyle = (
    { brand: { background, backgroundGradient, backgroundImage, headerSize }, fonts: { fontFamily } }: InfoDesignModel,
    isPreview: boolean,
): CSSProperties => {
    const pos = isPreview && !forceHeader ? `center calc(50% - ${calcHeaderHeight(headerSize)}px)` : 'center';
    const withGradient = background === BackgroundType.GRADIENT;
    const backgroundImageStyle = `url(${CDN_URL + backgroundImage})`;

    const img = useMemo(
        () =>
            backgroundImage
                ? {
                      backgroundImage: withGradient
                          ? `${backgroundGradient}, ${backgroundImageStyle}`
                          : backgroundImageStyle,
                      backgroundPosition: pos + (withGradient ? '' : ''),
                      backgroundRepeat: 'no-repeat' + (withGradient ? ', no-repeat' : ''),
                      backgroundSize: withGradient ? '100%, cover' : 'cover',
                  }
                : withGradient
                ? {
                      backgroundImage: `${backgroundGradient}`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '100',
                  }
                : {},
        [backgroundGradient, backgroundImage, pos, withGradient],
    );

    return useMemo(
        () => ({
            fontFamily,
            // rowGap: questionGap,
            backgroundAttachment: 'fixed',
            ...img,
        }),
        [fontFamily, img],
    );
};
